<template>
  <div class="bg">
    <!--  轮播图   -->
    <Banner :banner="swiperList"/>
    <!--  资讯   -->
    <reveal-animation ID="news">
      <News :newsList="newsList"/>
    </reveal-animation>
    <!--  联盟服务   -->
    <reveal-animation ID="service">
      <Service/>
    </reveal-animation>
    <!--  标准文档   -->
    <template v-if="docList.length">
      <reveal-animation ID="doc">
        <Doc :docList="docList"/>
      </reveal-animation>
    </template>
    <!--  联盟成员   -->
    <reveal-animation ID="members">
      <Members :partnersList="partnersList"/>
    </reveal-animation>
    <!--  加入我们   -->
    <Join/>
  </div>
</template>
<script>
import RevealAnimation from "@/components/common/RevealAnimation";
import Banner from "@/components/common/Banner";
import News from "@/views/index/components/News";
import Service from "@/views/index/components/Service";
import Doc from "@/views/index/components/Doc";
import Members from "@/views/index/components/Members";
import Join from "@/views/index/components/Join";
import {singleHomeSever, singleNewsSever} from "@/common/api-config";


export default {
  components: {Join, Members, RevealAnimation, News, Banner, Service, Doc},
  created() {
    this.queryBannerList();
    this.queryNewsList();
    this.queryRecommendList();
    this.queryAllianceMemberList();
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  data() {
    return {
      docList: [],
      swiperList: [], //banner
      newsList: [], //资讯
      partnersList: [],
      flag: false,
    };
  },
  methods: {
    //获取banner
    queryBannerList() {
      singleHomeSever.queryBannerList({
        type: 1,
      }).then(res => {
        if (res.code == 0) {
          this.swiperList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    queryRecommendList() {
      singleHomeSever.queryRecommendList({}).then(res => {
        if (res.code == 0) {
          this.docList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    queryAllianceMemberList() {
      singleHomeSever.queryAllianceMemberList({}).then(res => {
        if (res.code == 0) {
          this.partnersList = res.data;
          // this.flag = this.partnersList.some(item => item.category == 4)
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //获取资讯
    queryNewsList() {
      singleNewsSever.queryNewsList({
        page: 1,
        perPage: 5,
      }).then(res => {
        if (res.code == 0) {
          this.newsList = res.data.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    openModal() {
      this.$msgBox
          .accountWhiteMessageBox({
            title: "",
            content: ""
          })
          .then(async data => {
          })
          .catch(val => {
          });
    },
    lookMore() {
      let routeUrl = this.$router.resolve({
        path: '/documents/',
      })

      window.open(routeUrl.href, '_blank')
    },
    getInfo(index) {
      this.homeData[index].hover = true;
      // this.homeData=JSON.parse(JSON.stringify(this.homeData))//深拷贝监听数组变化
    },
    drawOut(index) {
      this.homeData[index].hover = false;
      // this.homeData=JSON.parse(JSON.stringify(this.homeData))
    },
  }
};
</script>
<style lang="scss" scoped>

</style>
